'use client'

import React, { useRef } from 'react'

import { useClickOutside } from '../../hooks/useClickOutside'

import { Box } from '@chakra-ui/react'

import type { ColorScheme } from '../../types'
import {
  listSelectorContainerStyles,
  listSelectorDividerStyles,
  listSelectorIconStyles,
  listSelectorItemStyles,
} from './ListSelector.styles'

export type ListSelectorItem = {
  icon?: React.ReactNode
  label: string
  onClick: () => void
}

export type ListSelectorProps = {
  items: ListSelectorItem[]
  onDismiss?: () => void
  colorScheme?: ColorScheme
}

export const ListSelector = ({
  items,
  onDismiss,
  colorScheme = 'dark',
}: ListSelectorProps) => {
  const containerRef = useRef<HTMLDivElement>(null)
  useClickOutside([containerRef], () => onDismiss?.())

  return (
    <Box ref={containerRef} {...listSelectorContainerStyles(colorScheme)}>
      {items.map((item, i) => (
        <Box
          key={item.label}
          {...(i > 0 && listSelectorDividerStyles(colorScheme))}
          {...listSelectorItemStyles(colorScheme)}
          onClick={item.onClick}
        >
          {item.icon && (
            <Box as='span' {...listSelectorIconStyles}>
              {item.icon}
            </Box>
          )}
          {item.label}
        </Box>
      ))}
    </Box>
  )
}
